import { lazy } from "react";

import Loadable from "../components/Loadable";

const ShareTokenPage = Loadable(
  lazy(() => import("../pages/public/ShareToken"))
);

const PublicRoutes = {
  path: "/",
  children: [
    {
      path: "/share/:token",
      element: <ShareTokenPage />,
    },
  ],
};

export default PublicRoutes;
